import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-302">
      <div className="max-w-3xl mx-auto" data-id="element-303">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-304">
          EL RESULTADO PARA VOS COMO DOCENTE
        </h2>

        <p className="text-xl mb-4 font-medium text-center" data-id="element-305">
          Con este material vas a lograr:
        </p>

        <div className="bg-green-50 rounded-2xl p-5 border border-green-200 mb-4" data-id="element-306">
          <ul className="space-y-2 text-xl font-bold text-gray-800" data-id="element-307">
            <li className="flex items-start" data-id="element-308">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-309" />
              <span data-id="element-310">Ahorrar horas de preparación.</span>
            </li>
            <li className="flex items-start" data-id="element-311">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-312" />
              <span data-id="element-313">Tener todo organizado durante el año.</span>
            </li>
            <li className="flex items-start" data-id="element-314">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-315" />
              <span data-id="element-316">Trabajar efemérides con profundidad.</span>
            </li>
            <li className="flex items-start" data-id="element-317">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-318" />
              <span data-id="element-319">
                Proponer actividades realmente pensadas para secundaria.
              </span>
            </li>
            <li className="flex items-start" data-id="element-320">
              <CheckIcon className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-321" />
              <span data-id="element-322">Promover análisis, reflexión y pensamiento crítico.</span>
            </li>
          </ul>
        </div>

        <p className="text-2xl font-black text-center text-gray-900" data-id="element-323">
          <span className="px-2 bg-[#FFFFFF]" data-id="element-324">
            Todo sin perder tiempo buscando material en internet.
          </span>
        </p>
      </div>
    </section>;
}